<template lang="html">
  <section class="navbar-search" @click="focusOnInput">
    <form @submit.prevent="a => a" class="form-inline px-1 my-lg-0" style="position: relative">
      <div class="input-group" style="width: 100%;">
<!--        Fix for v-model not updating on GBoard and other Android keyboards -->
<!--        @input="$event.target.composing = false"-->
        <input
          v-model="search"
          @input="$event.target.composing = false"
          :id="id"
          name="q"
          :disabled="isFetching"
          maxlength="50"
          @keydown.enter="updateSearch"
          class="form-control"
          type="search"
          autocomplete="off"
          aria-label="Search">
        <div class="input-group-append mod">
          <div v-if="showCheckbox" class="category-checkbox d-none d-lg-flex align-self-center">
            <input class="form-check-input mx-0 my-auto"
                   type="checkbox"
                   :id="`${id}checkbox1`"
                   :disabled="isFetching"
                   @change="searchCategoryFilter"
                   style="width: initial; cursor: pointer">
            <label class="desktop-checkbox-label px-1 my-auto" :for="`${id}checkbox1`">
              {{checkboxLabel}}
            </label>
          </div>
          <button class="navbar-search-button btn btn-outline-primary"
                  :disabled="isFetching"
                  @focus="focusOnInput"
                  @click="updateSearch"
                  type="submit"
                  aria-label="Buscar">
            <i class="fa fa-search pt-1 pt-sm-0"></i>
          </button>
        </div>
      </div>
      <div v-if="showCheckbox" class="mobile-checkbox my-3 pl-2 align-self-center" tabindex="0">
        <input class="mobile-checkbox-input mx-0 my-auto"
               type="checkbox"
               :id="`${id}checkbox2`"
               @change="searchCategoryFilter"
               style="width: initial; cursor: pointer">
        <label class="mobile-checkbox-label my-auto pl-2 focus" :for="`${id}checkbox2`" style="font-size: 1rem;">
          {{checkboxLabel}}
        </label>
      </div>
    </form>
  </section>
</template>

<script>
import store from '@/store'

export default {
  props: {
    id: String
  },

  data: () => ({
    search: '',
    categoryFilter: null
  }),

  computed: {
    q: () => store.state.q,

    isFetching: () => store.state.isFetching,

    location: () => ({
      lat: store.state.filters.location.lat,
      lon: store.state.filters.location.lon,
      city: store.state.filters.location.city,
      distance: store.state.search.distance
    }),

    filterLocationEmpty () {
      return !(
        !!this.location.lat ||
        !!this.location.lon ||
        !!this.location.city
      )
    },

    showCheckbox () {
      return this.inCategory || this.inFavorites || this.inFollowedUsersPublications || this.inProfile || this.inUserPublications
    },

    checkboxLabel () {
      if (this.inCategory) {
        return this.breadcrumbCategoryFilter ? `Sólo en ${this.breadcrumbCategoryFilter.name}` : 'Sólo en esta categoría'
      } else if (this.inFavorites) {
        return 'Sólo en Mis favoritos'
      } else if (this.inProfile) {
        return 'Sólo en este usuario'
      } else if (this.inUserPublications) {
        return 'Sólo en Mis publicaciones'
      } else {
        return 'Sólo en esta sección'
      }
    },

    inCategory () { return this.$route.name === 'category' && this.breadcrumb.length > 0 },

    inFollowedUsersPublications () { return this.$route.name === 'userFollowedUserPublications' },

    inFavorites () { return this.$route.name === 'userFavorites' },

    inProfile () { return this.$route.name === 'profile' },

    inUserPublications () { return this.$route.name === 'userPublications' },

    breadcrumb: () => store.state.category.breadcrumb,

    topCategories () {
      const breadcrumbLength = this.breadcrumb && this.breadcrumb.length
      let topCategories = []
      for (let i = 0; i < breadcrumbLength && i < 3; i++) {
        topCategories.push(this.breadcrumb[i])
      }
      return topCategories
    },

    breadcrumbCategoryFilter () { return this.topCategories.length > 0 && this.topCategories[this.topCategories.length - 1] }
  },

  watch: {
    q (n) {
      this.search = n
    }
  },

  methods: {
    updateSearch (e) {
      dispatchEvent(new Event('uncover'))

      // The API doesn't allow for searches with less than 2 characters
      if (this.search.length < 2) {
        document.getElementById(this.id).blur()
        return
      }

      e.target.blur()
      store.dispatch('category/setPage', 1)
      // Reset search distance
      store.dispatch('setDistance', -1)
      const query = { q: this.search }

      if (this.inFavorites && this.categoryFilter === 'favorites') {
        this.filterFavorites(query)
      } else if (this.inFollowedUsersPublications && this.categoryFilter === 'followedUsersPublications') {
        this.filterFollowedUsersPublications(query)
      } else if (this.inProfile && this.categoryFilter === 'profile') {
        this.filterProfile(query)
      } else if (this.inUserPublications && this.categoryFilter === 'userPublications') {
        this.filterUserPublications(query)
      } else {
        this.filterCategory(query)
      }

      const checkbox1 = document.getElementById(`${this.id}checkbox1`)
      const checkbox2 = document.getElementById(`${this.id}checkbox2`)
      // After pushing the search, reset category filter checkbox and param
      !!checkbox1 && (checkbox1.checked = false)
      !!checkbox2 && (checkbox2.checked = false)
      this.categoryFilter = null
    },

    filterFavorites (query) {
      this.$router.push({ name: 'userFavorites', query },
        () => {},
        () => {
          store.dispatch('setIsFetching', true)
          store.dispatch('favorites/fetchPublications', query)
            .finally(() => { store.dispatch('setIsFetching', false) })
        })
    },

    filterCategory (query) {
      if (this.filterLocationEmpty) {
        store.dispatch('filters/setLocation', {
          lat: store.state.location.lat,
          lon: store.state.location.lon,
          city: store.state.currentCity
        })
      }

      const params = this.categoryFilter ? this.$route.params : { category: 'todas' }

      query = {
        ...query,
        ...this.location
      }

      let urlQuery = { ...query }

      if (this.categoryFilter) {
        urlQuery = {
          'category_Categorías': `${this.categoryFilter.name}_${this.categoryFilter.id}`,
          ...urlQuery
        }
        query = {
          'category': this.categoryFilter.id,
          ...query
        }
      }

      this.categoryFilter && store.dispatch('filters/resetState')
      this.$router.push({ name: 'category', params, query: urlQuery },
        () => {},
        () => {
          store.dispatch('setIsFetching', true)
          store.dispatch('category/fetchPublications', { ...query })
            .finally(() => {
              store.dispatch('setIsFetching', false)
              dispatchEvent(new Event('uncover'))
            })
        })
    },

    filterFollowedUsersPublications (query) {
      if (this.filterLocationEmpty) {
        store.dispatch('filters/setLocation', {
          lat: store.state.location.lat,
          lon: store.state.location.lon,
          distance: store.state.search.distance
        })
      }

      query = {
        ...query,
        ...this.location
      }

      const params = {
        ...query,
        page: store.state.category.page
      }

      this.$router.push({ name: 'userFollowedUserPublications', query },
        () => {},
        () => {
          store.dispatch('setIsFetching', true)
          store.dispatch('user/fetchFollowedPublications', params)
            .finally(() => { store.dispatch('setIsFetching', false) })
        })
    },

    filterProfile (query) {
      store.dispatch('filters/resetState')
      // Params & Query for routing to ProfilePage component
      const routeParams = this.$route.params
      const routeQuery = {
        ...query,
        page: 1
      }
      // Params to fetch pubs if already in ProfilePage component
      const fetchParams = {
        user_id: routeParams.id,
        page: 1
      }
      if (routeQuery.q) fetchParams.q = routeQuery.q
      // Routes to new path, or fetches pubs if retrying same search
      this.$router.push({ name: 'profile', params: routeParams, query: routeQuery },
        () => {},
        () => {
          store.dispatch('setIsFetching', true)
          store.dispatch('profile/fetchPublications', fetchParams)
            .finally(() => { store.dispatch('setIsFetching', false) })
        })
    },

    filterUserPublications (query) {
      store.dispatch('filters/resetState')
      // Params & Query for routing to user's publications component
      const routeParams = this.$route.params
      const routeQuery = {
        ...query,
        page: 1
      }
      // Params to fetch pubs if already in ProfilePage component
      const fetchParams = {
        page: 1
      }
      if (routeQuery.q) fetchParams.q = routeQuery.q
      // Routes to new path, or fetches pubs if retrying same search
      this.$router.push({ name: 'userPublications', params: routeParams, query: routeQuery },
        () => {},
        () => {
          store.dispatch('setIsFetching', true)
          store.dispatch('user/fetchPublications', fetchParams)
            .finally(() => { store.dispatch('setIsFetching', false) })
        })
    },

    focusOnInput (e) {
      if (document.activeElement.id !== 'searchBox1' || document.activeElement.id !== 'searchBox2') {
        if (this.id === 'searchBox2') {
          dispatchEvent(new Event('cover'))
        }
        document.getElementById(this.id).focus()
      } else {
        document.activeElement.blur()
      }
    },

    searchCategoryFilter (e) {
      // When "solo en" checkbox is checked, set categoryFilter to a specific value, depending on the current page
      if (e.target.checked) {
        if (this.inCategory) {
          this.categoryFilter = !!this.breadcrumbCategoryFilter && this.breadcrumbCategoryFilter
        } else if (this.inFavorites) {
          this.categoryFilter = 'favorites'
        } else if (this.inProfile) {
          this.categoryFilter = 'profile'
        } else if (this.inUserPublications) {
          this.categoryFilter = 'userPublications'
        } else if (this.inFollowedUsersPublications) {
          this.categoryFilter = 'followedUsersPublications'
        }
      } else {
        this.categoryFilter = null
      }
    }
  },

  mounted () {
    this.search = this.q
  }
}
</script>

<style lang="scss">
@import '../../scss/aspect';
@import '../../scss/colors';
@import '../../scss/breakpoints';

.navbar-search {

  top: 6px;

  &-button {
    padding: 0 0.25rem !important;
  }

  & form {
    width: 100%;

    & input {
      background-color: #f7f7f7;
      border-radius: 4px !important;
      padding-right: 2.5rem;
    }

    & .mod {
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: max-content;
      z-index: 3;
      background-color: transparent;

      & button {
        border: none;
        background-color: inherit;

        & i {
          font-size: 1.5rem;
        }
      }
    }

    & .mobile-checkbox {
      width: max-content;
      display: none;

      &-input {
        height: 16px !important;
        width: 16px !important;
      }

      &-label {
        text-overflow: ellipsis;
      }
    }

    & .desktop-checkbox-label {
      font-size: small;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: start;
      display: block;
      cursor: pointer;
    }
  }

  &-brand {
    position: absolute;
    top: 4px;
    left: 4px;
    bottom: 4px;
    max-height: 1.75rem;
    margin: auto;
    opacity: 0.5;
    z-index: 1000;
  }

  .category-checkbox {
    border-right: 1px solid lightgrey;
    border-left: 1px solid lightgrey;
    width: initial;
    max-width: 200px;
    height: 2rem;
    padding: 0 6px !important;
  }
}

@media screen and (min-width: map-get($grid-breakpoints, "lg")) {
  .navbar-search {
    max-width: 100%;
    flex-grow: 1;
    padding: 0 0 0 2vw;

    & input {
      padding-left: 1rem;
      padding-right: 2rem;
    }

    &-brand {
      display: none;
    }

    & div {
      width: 100%;
    }

    & div input {
      width: 80%;
    }

    & div div {
      width: 20%;
    }
  }
}

@media screen and (max-width: map-get($grid-breakpoints, "lg")) {
  .navbar-search {
    &:focus-within {
      transition: ease-in .1s;
      position: absolute;
      left: 0;
      right: 0;
      background-color: $white;
      max-width: 100%;
      margin-left: auto;
      margin-right: auto;
      width: 100% !important;
      z-index: 10;

      & input {
        color: black;
        padding-left: 1rem !important;
        padding-right: 2rem !important;
      }

      & .mobile-checkbox {
        display: flex;
        width: 100%;
      }
    }

    width: 48px;

    & input {
      color: transparent;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/TheNavbarSearch.vue